import { atom } from "jotai";
import { State } from "./State";
import { fetchBase, postBase } from "./BaseApi";

export type User = {
  userId: string;
  fpId: number;
  userName: string;
  email: string;
  diagnosisType: string;
  isCompare: boolean;
  isPartner: boolean;
  isChildren: boolean;
  postalCode: string;
  childrenCount?: string | number | null;
  birthYear?: string | null;
  annualSalary?: string | number | null;
  childrenColumn1?: string | null;
  childrenColumn2?: string | null;
  childrenColumn3?: string | null;
  childrenColumn4?: string | null;
  childrenColumn5?: string | null;
  currentPoint: number;
  numberOfCompletedRainbowbadge: number;
  numberOfCompletedGoldbadge: number;
  numberOfCompletedGreenbadge: number;
  createdAt: string;
  updatedAt: string;
  lastAccessedAt: string;
  isWithin24hours: boolean;
};

export type UserTopic = {
  topicId: number;
  interestLevel: string;
};

export type UserParam = {
  isPartner: boolean;
  isChildren: boolean;
  postalCode: string;
  userTopic: UserTopic[];
};

export type PostUnregisteredUserParam = {
  diagnosisType:string;
  emailAddress: string;
};

export type PostUserGiftEmailAuthParam = {
  emailAddress: string;
  giftId: string;
  pointOwnerId?: number;
};

const uri = "api/users";
const unregisteredUri = "api/unregistered-users/create";
const giftEmailAuthUri = "api/users/gift-email-auth";

export const fetchUserAtom = atom<State<User> | null>(null);

export const fetchUser = () => {
  return fetchBase<User>(uri, fetchUserAtom);
};

export const postUserAtom = atom<State<User> | null>(null);
export const postUsers = () => {
  return postBase<User, UserParam>(uri, postUserAtom);
};

export const postUnregisteredUserAtom = atom<State<null> | null>(null);
export const postUnregisteredUsers = () => {
  return postBase<null, PostUnregisteredUserParam>(
    unregisteredUri,
    postUnregisteredUserAtom
  );
};

export const postUserGiftEmailAuthAtom = atom<State<null> | null>(null);
export const postUserGiftEmailAuth = () => {
  return postBase<null, PostUserGiftEmailAuthParam>(
    giftEmailAuthUri,
    postUserGiftEmailAuthAtom
  );
};
